import styled from 'styled-components';
import Subtitle from '@components/Subtitle';
import TextLabel from '@components/Subtitle/components/TextLabel';

const StyledSubtitle = styled(Subtitle)`
  margin: 0;
  ${TextLabel} {
    margin: 0;
  }
`;

export default StyledSubtitle;
